import {
  IFetchFileAction,
  IFetchFileActionPayload,
  IUploadFileDataAction,
  IUploadFileDataActionPayload,
  IUploadFormFileDataAction,
  IUploadFormFileDataActionPayload,
  IUploadFormFilesDataAction,
  IUploadFormFilesDataActionPayload,
  IUploadFormLogoActionPayload,
  IUploadFormLogoDataAction,
} from "@common/redux/upload/interface";

const prefix = "upload/";

export const uploadActions = {
  UPLOAD_FILE: `${prefix}UPLOAD_FILE`,
  FETCH_FILE: `${prefix}FETCH_FILE`,
  UPLOAD_FORM_FILE: `${prefix}UPLOAD_FORM_FILE`,
  UPLOAD_FORM_LOGO: `${prefix}UPLOAD_FORM_LOGO`,
  UPLOAD_FORM_FILES: `${prefix}UPLOAD_FORM_FILES`,
};

export const uploadFileDataAction = (
  payload: IUploadFileDataActionPayload
): IUploadFileDataAction => {
  return {
    type: uploadActions.UPLOAD_FILE,
    payload,
  };
};

export const uploadFormLogoAction = (
  payload: IUploadFormLogoActionPayload
): IUploadFormLogoDataAction => {
  return {
    type: uploadActions.UPLOAD_FORM_LOGO,
    payload,
  };
};

export const fetchFileAction = (
  payload: IFetchFileActionPayload
): IFetchFileAction => {
  return {
    type: uploadActions.FETCH_FILE,
    payload,
  };
};

export const uploadFormFileDataAction = (
  payload: IUploadFormFileDataActionPayload
): IUploadFormFileDataAction => {
  return {
    type: uploadActions.UPLOAD_FORM_FILE,
    payload,
  };
};
export const uploadFormFilesDataAction = (
  payload: IUploadFormFilesDataActionPayload
): IUploadFormFilesDataAction => {
  
  return {  
    type: uploadActions.UPLOAD_FORM_FILES,
    payload,
    
  };
  
};

